import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

export const PrivacyPolicy = () => {
    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="card">
                        <div className="card-body">
                            <h1 className="card-title text-center">Privacy Policy for Ecommerce</h1>

                            <p className="card-text"><strong>Privacy Policy</strong></p>
                            <p className="card-text">
                            Thank you for using Ecommerce. This Privacy Policy explains how we collect, use, and protect your personal information. By using our service, you agree to the collection and use of information as described in this policy.

                                This Privacy Policy describes our policies and procedures on the collection, use and disclosure of your information when you use the Service and tells you about your privacy rights and how the law protects you.
                            </p>

                         

                            <h2>User Data Collection</h2>
                            <p className="card-text">
                                We collect the following personal information for account creation purposes:
                            </p>
                            <ul className="card-text">
                                <li>Name</li>
                                <li>Password</li>
                                <li>Email address</li>
                                <li>Profile picture</li>
                                <li>Address</li>
                            </ul>

                            <h2>Data Usage</h2>
                            <p className="card-text">
                                The information collected is used solely for creating and managing your account on Ecommerce. We do not use this information for any other purpose without your consent.
                            </p>

                            <h2>Data Sharing</h2>
                            <p className="card-text">
                                We do not share your personal information with third parties.
                            </p>

                            <h2>Security Measures</h2>
                            <p className="card-text">
                                We take reasonable measures to protect your personal information from unauthorized access, use, alteration, or destruction. These measures include encryption, secured servers, and regular security audits.
                            </p>

                            <h2>Cookies</h2>
                            <p className="card-text">
                                We use cookies to enhance your user experience and for authentication purposes. Cookies are small pieces of data stored on your device that help us recognize you when you return to our service.
                            </p>

                            <h2>Legal Compliance</h2>
                            <p className="card-text">
                                We comply with applicable data protection laws and regulations. If you have questions about how we handle your personal information, please contact us using the information provided below.
                            </p>

                            <h2>User Rights</h2>
                            <p className="card-text">
                                You have the right to:
                            </p>
                            <ul className="card-text">
                                <li>Access, update, or delete your personal information.</li>
                                <li>Close your account and delete your personal data associated with it.</li>
                            </ul>

                            <h2>Contact Us</h2>
                            <p className="card-text">
                                If you have any questions about this Privacy Policy, please contact us at <a href="mailto:hurmain.dev@gmail.com">hurmain.dev@gmail.com</a>.
                            </p>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
